export type FaqItem = {
  question: string;
  answer: string;
  /**
   * Opsiyonel: cevabın içindeki özel token'lar yerine FaqSection'ın renderer'ı
   * interaktif element basar.
   * - `subscription`: metni abonelik paketleri pop-up'ını açan butona çevirir.
   * - `link`: belirtilen metni verilen href'e giden Next Link'e çevirir.
   * Bir item ya `subscription` ya `link` token kullanmalı (ikisi birden değil).
   */
  tokens?: {
    /** `answer` içinde yer alan metni, abonelik pop-up'ını açan link'e dönüştürür. */
    subscription?: string;
    /** `answer` içinde yer alan `text` metnini, `href`'e giden link'e dönüştürür. */
    link?: { text: string; href: string };
  };
};

// ⚠️ BU METİNLER GOOGLE'A DA GİDİYOR. app/page.tsx:46-55 FAQ_ITEMS'i hem ana
// sayfa akordeonunda gösteriyor hem `FAQPage` JSON-LD olarak yayınlıyor; ayrıca
// app/about/page.tsx aynı listeyi kullanıyor. Yani buradaki bir cümle yalnız
// sayfada değil, arama sonuçlarında da beyan edilmiş sayılır.
//
// ⚠️ O-12: "Türkiye'nin ILK aracısız-komisyonsuz platformu" ifadesi kaldırıldı.
// İspatlanamaz bir üstünlük iddiasıydı (TKHK m.61) ve CLAUDE.md'deki tek resmî
// slogandan da sapıyordu: "Türkiye'nin komisyonsuz kısa süreli konaklama
// platformu". Aynı cümle app/about/page.tsx'te ve blog_posts tablosundaki
// 'konakla-nedir' yazısında da vardı; üçü birden düzeltildi.
//
// ⚠️ BU SATIRI BÖLME. tests/unit/marka-dili.test.ts SATIR BAZLI muafiyet
// kullanıyor (SATIR_MUAF): satırda "rezervasyon" yasaklı sözcüğü geçiyor ama
// aynı satırda "Turizm Bakanlığı" bulunduğu için hoş görülüyor. Cümleyi birden
// çok satıra bölersen ya da o satırdan "Turizm Bakanlığı"nı çıkarırsan test kırılır.
//
// ⚠️ K-8 / O-29: iptal-iade cevabı ÜÇ yerden yanlıştı —
//   · "Mevcut dönem sonuna kadar tüm özelliklerden yararlanmaya devam edersiniz"
//     iade BAŞARILI olunca YANLIŞ: plan o anda Ücretsiz'e düşüyor
//     (app/api/subscriptions/cancel/route.ts → downgradeToFree).
//   · "14 gün içerisinde ücret iadesi yapılır" KOŞULSUZ bir iade sözü gibi
//     okunuyordu; gerçek kural "satın almadan itibaren 14 gün İÇİNDE iptal
//     edilirse iade" — bambaşka bir şey.
//   · İş Ortağı Sözleşmesi §8.4 ve checkout onay metni ile çelişiyordu.
// Gün sayısı `REFUND_WINDOW_DAYS` sabitinden gelir; değiştirirsen bu cevabı,
// sözleşme §8.4'ü ve checkout onay metnini BİRLİKTE değiştir.
// tests/unit/k8-sozlesme-tutarliligi.test.ts üçünü birden kilitliyor.

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: "konakla nedir?",
    answer:
      "konakla sadece Turizm Bakanlığı tarafından onaylı ve belgeli evlerin bulunduğu, Türkiye'nin komisyonsuz kısa süreli konaklama platformudur. konakla üzerinden ödeme ve rezervasyon yapılmaz. Ev sahipleri ile misafirler doğrudan iletişim sağlar.",
  },
  {
    question: "konakla'da ilan vermek ücretli mi?",
    answer:
      "İlk ilanınız her zaman ücretsizdir! Birden fazla mülkünüz varsa, ihtiyacınıza uygun abonelik paketlerimizi inceleyebilirsiniz.",
    tokens: { subscription: "abonelik paketlerimizi" },
  },
  {
    question: "Misafirlerden veya ev sahiplerinden komisyon alıyor musunuz?",
    answer:
      "Hayır! konakla'nın en önemli farkı budur. Ne misafirlerden ne de ev sahiplerinden komisyon alınmaz. Gelir modelimiz ev sahibi temelli abonelik üzerine kuruludur.",
  },
  {
    question: "Ödeme nasıl gerçekleşiyor?",
    answer:
      "konakla üzerinden ödeme yapılmaz. Misafir ve ev sahibi doğrudan iletişime geçer, ödeme kendi aralarında gerçekleşir. Bu sayede komisyon kesintisi olmadan tam tutar ev sahibine ulaşır.",
  },
  {
    question: "Turizm Bakanlığı belgesi zorunlu mu?",
    answer:
      "Evet, Türkiye'de kısa süreli kiralama yapılan her mülkün T.C. Turizm Bakanlığı'ndan alınmış 'Turizm Amaçlı Konut Kiralama İzin Belgesi' bulunması zorunludur. konakla olarak sadece belgeli mülkleri onaylıyoruz.",
  },
  {
    question: "İlanım ne kadar sürede onaylanır?",
    answer:
      "Turizm Bakanlığı belgeniz ve ilan bilgileriniz eksiksiz ise aynı gün içinde onay alabilirsiniz. Eksik veya hatalı bilgi durumunda sizinle iletişime geçilir.",
  },
  {
    question: "Nasıl ilan eklerim?",
    answer:
      "İlanınızı dakikalar içerisinde, kolay bir şekilde ekleyebilirsiniz. İlk ilan ücretsiz. Buyrun.",
    tokens: { link: { text: "Buyrun", href: "/for-hosts" } },
  },
  {
    question: "Aboneliğimi istediğim zaman iptal edebilir miyim?",
    answer:
      "Evet, aboneliğinizi istediğiniz zaman iptal edebilirsiniz. Satın alma tarihinden itibaren 14 gün içinde iptal ederseniz ödediğiniz tutarın tamamı iade edilir; iade tamamlandığında planınız Ücretsiz plana döner. Bu sürenin dışında iptal ederseniz ücret iadesi yapılmaz, ancak dönem sonuna kadar planınızın tüm özelliklerinden yararlanmaya devam edersiniz.",
  },
];
